export const RIGHT_RAIL_MIN_WIDTH = 409;

export const MAIN_CONTAINER_MIN_WIDTH = 360;

// consistent w/ retail
export const FULL_PAGE_MAX_WIDTH = 1450;

export const PAYMENT_METHOD_CREDIT_TYPE = 'payment_method_added';
